import Vue from 'vue'
import Vuex from 'vuex'
import userModule from './modules/UserModule'
import locomotivesModule from './modules/LocomotivesModule'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    userModule,
    locomotivesModule
  }
})
